<template>
  <section class="list list--titled">
    <h1 v-if="title">{{ title }}</h1>
    <div v-if="jobs.length" class="list__jobs">
      <template v-for="(job, i) in jobs">
        <div v-if="job && job._id" :key="`TitledJobList${i}-${job._id}`" class="list__job">
          <job-ad-card
            v-if="job.is_ad"
            :company="job.company"
            :job="job"
            :observer="observerObj"
            :is-interact="isInteraction(job._id)"
            :tracking-params="trackingParams"
            :session-id="biddingSession"
            :request-id="requestId"
            :bidding-id="biddingId"
            :source="source"
            :source-section="sourceSection"
            :position="i"
          />
          <job-card
            v-else
            :company="job.company"
            :job="job"
            :observer="observerObj"
            :is-interact="isInteraction(job._id)"
            :tracking-params="trackingParams"
            :session-id="sessionId"
            :source="source"
            :source-section="sourceSection"
            :position="i"
          />
        </div>
      </template>
    </div>
    <div v-if="showError" class="list__norecord">
      <p class="list_empty">
        <span>{{ error }}</span>
      </p>
    </div>
  </section>
</template>

<script>
import ListMixin from '../../mixins/list'

export default {
  computed: {
    error() {
      return this.errorText || this.$t('general.noRecord')
    },
  },
  mixins: [ListMixin],
  props: {
    errorText: {
      default: '',
      type: String,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.list__norecord {
  @apply text-center w-full;
  margin-top: 50px;
  margin-bottom: 50px;
}
.list_empty {
  @apply text-cbody2 font-cbody2;
  @apply whitespace-pre-wrap;
}

@screen mobile {
  h1 {
    @apply mb-3 text-xl;
  }

  .list__job {
    @apply w-full;
  }
  >>> .jc {
    @apply mx-auto;
  }
}

@screen desktop {
  h1 {
    @apply mb-2 px-1;
  }
  .list_empty {
    @apply text-cbody1 font-cbody1;
  }
}
</style>
